import { Box, Link as MuiLink, styled } from '@mui/material';

import { Colors } from 'Themes/colors';
import { Spacing } from 'Themes/spacing';

import { CloseIconButton } from '../CloseIconButton';

export const StyledContainer = styled(Box)`
  min-width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
`;

export const Wrapper = styled(Box)`
  position: relative;
  background: ${Colors.white};
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: ${Spacing.large};
  flex-wrap: wrap;
  gap: ${Spacing.large};
`;

export const LeftColumn = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.small};
`;

const linkStyle = `
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 100%;
  text-decoration-line: underline;
  white-space: nowrap;
  cursor: pointer;
  color: ${Colors.blue} !important;
  &:visited {
    color: ${Colors.blue} !important;
  }
`;

export const ButtonLink = styled(MuiLink)`
  vertical-align: baseline;

  ${linkStyle}
`;

export const StyledMuiLink = styled(MuiLink)`
  ${linkStyle}
`;

export const StyledCloseButton = styled(CloseIconButton)`
  position: absolute !important;
  top: ${Spacing.small};
  right: ${Spacing.small};
`;
